// extracted by mini-css-extract-plugin
export default {"overlay":"ModalUniversal_overlay__W+eOu","content":"ModalUniversal_content__JDfAn","closeBtn":"ModalUniversal_closeBtn__ASRM-"};